import React, { PureComponent, Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link, Button } from 'formlabs-web-components/Link';
import Cookies from 'js-cookie';
import { setUserData as setUserDataAction } from '../../ducks/auth';

import FlyOutModal from '../modal/FlyOutModal';
import { analytics, getCookieDomain } from '../../utils';
import './MenuSignIn.module.css';

const CLIENT_ID = process.env.RAZZLE_CLIENT_ID;
const CLIENT_SECRET = process.env.RAZZLE_CLIENT_SECRET;
const API_URL = process.env.RAZZLE_API_URL;
const SigninLink = ({ typeColor, isAuthenticated, t, firstName }) => (
  <Link
    to="https://formlabs.com/dashboard/"
    styleName="button"
    style={{ color: typeColor }}
  >
    <span>
      {isAuthenticated
        ? t('Hi, {{name}}', { name: firstName ? firstName : 'User' })
        : t('Sign In')}
    </span>
  </Link>
);

const Form = ({ hasError, t, onSubmit }) => (
  <Fragment>
    <form action={`${API_URL}/o/token/`} method="POST" onSubmit={onSubmit}>
      <input
        type="text"
        placeholder={t('Email/Username')}
        id="username"
        name="username"
        aria-label={t('Your Formlabs username or email address')}
      />
      <input
        type="password"
        placeholder={t('Password')}
        id="password"
        name="password"
        aria-label={t('Password used for your Formlabs account')}
      />
      {hasError && (
        <p styleName="failed-login">
          {t('Username or password is incorrect.')}
        </p>
      )}
      <div>
        <input type="submit" value={t('Log In')} />
      </div>
      <div styleName="password-reset">
        <Link to="https://formlabs.com/dashboard/#forgot-password/request">
          {t('Reset password?')}
        </Link>
      </div>
    </form>
    <div>
      <Button to="https://formlabs.com/dashboard/#register" color="light">
        {t('Create an Account')}
      </Button>
    </div>
  </Fragment>
);

const UserMenu = ({ hasError, t, onSignOut }) => (
  <Fragment>
    <div styleName="signed-in">
      <Link to="https://formlabs.com/dashboard/">{t('Dashboard')}</Link>
    </div>
    <div styleName="signed-in">
      <Link to={`${process.env.RAZZLE_MAGENTO_URL}/customer/account/index/`}>
        {t('My Account')}
      </Link>
    </div>
    <div styleName="signed-in">
      <Link to={`${process.env.RAZZLE_MAGENTO_URL}/sales/order/history/`}>
        {t('My Orders')}
      </Link>
    </div>
    <div styleName="signed-in">
      <Link onClick={onSignOut}>{t('Sign Out')}</Link>
      {hasError && (
        <p styleName="failed-logout">
          {t('An error occured during sign out process, please try again.')}
        </p>
      )}
    </div>
  </Fragment>
);

class SignIn extends PureComponent {
  state = {
    hasError: false
  };

  onFormSubmit = async e => {
    e.preventDefault();
    this.setState({ hasError: false });

    const form = e.target;
    let form_data = new FormData(form);
    form_data.append('grant_type', 'password');
    form_data.append('client_id', CLIENT_ID);
    form_data.append('client_secret', CLIENT_SECRET);

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: form_data
      });
      const data = await response.json();

      if (data.access_token) {
        Cookies.set('flpc', data.access_token, {
          domain: getCookieDomain()
        });
        Cookies.remove('cart', { domain: getCookieDomain() });
        window.location.reload();
      } else {
        this.setState({ hasError: true });
        const { href, pathname } = window.location;
        analytics.track(
          'Login Attempt Failed',
          {
            category: 'Dashboard',
            path: pathname,
            statusCode: response.status,
            url: href,
            username: form_data.get('username')
          },
          {
            integrations: {
              Marketo: false,
              'Marketo V2': false
            }
          }
        );
      }
    } catch (error) {
      this.setState({ hasError: true });
      console.error('Error:', error);
    }
  };

  handleSignOut = () => {
    const flpc = Cookies.get('flpc');
    this.setState({ hasError: false });
    let form_data = new FormData();
    form_data.append('token', flpc);
    form_data.append('client_id', CLIENT_ID);
    form_data.append('client_secret', CLIENT_SECRET);
    fetch(`${API_URL}/o/revoke_token/`, {
      method: 'POST',
      body: form_data
    })
      .then(res => {
        Cookies.remove('flpc', { domain: getCookieDomain() });
        Cookies.remove('cart', { domain: getCookieDomain() });
        this.props.setUserData({
          username: null,
          firstName: null,
          lastName: null,
          email: null,
          dateJoined: null,
          lastLogin: null,
          id: null,
          groups: null
        });
        window.location.reload();
      })

      .catch(error => {
        console.error('Error:', error);
        this.setState({ hasError: true });
      });
  };

  render() {
    const { t, isAuthenticated } = this.props;
    const { hasError } = this.state;

    return (
      <div styleName="sign-in">
        {!isAuthenticated ? (
          <Form hasError={hasError} t={t} onSubmit={this.onFormSubmit} />
        ) : (
          <UserMenu hasError={hasError} t={t} onSignOut={this.handleSignOut} />
        )}
      </div>
    );
  }
}
const ModalContent = connect(
  state => {
    return {
      isAuthenticated: state.auth.isAuthenticated
    };
  },
  dispatch => {
    return {
      setUserData: data => {
        dispatch(setUserDataAction(data));
      }
    };
  }
)(SignIn);

const MenuSignIn = ({
  typeColor,
  isAuthenticated,
  t,
  firstName,
  setUserData
}) => {
  const flpc = Cookies.get('flpc');
  useEffect(() => {
    if (flpc) {
      fetch(`${API_URL}/printernet/v1/my/user/`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: `Bearer ${flpc}`,
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(res => {
          setUserData(res);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }
  }, []);
  return (
    <FlyOutModal modalWidth={280} modalContent={<ModalContent t={t} />}>
      <SigninLink
        typeColor={typeColor}
        isAuthenticated={isAuthenticated}
        t={t}
        firstName={firstName}
      />
    </FlyOutModal>
  );
};
export default compose(
  connect(
    state => {
      return {
        firstName: state.auth.firstName,
        isAuthenticated: state.auth.isAuthenticated
      };
    },
    dispatch => {
      return {
        setUserData: data => {
          dispatch(setUserDataAction(data));
        }
      };
    }
  ),
  withTranslation()
)(MenuSignIn);
